import { render, staticRenderFns } from "./ForgottenPasswordForm.vue?vue&type=template&id=496eb4e9&scoped=true&"
import script from "./ForgottenPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496eb4e9",
  null
  
)

export default component.exports